module.exports = __webpack_public_path__ + "img/en.d6baebb6.png";